import React, { FunctionComponent } from 'react'
import * as CookieConsent from 'vanilla-cookieconsent'
import { useTranslation } from 'gatsby-plugin-react-i18next'
import { ShieldCheckIcon } from '@heroicons/react/24/outline'

import { getFloatingButtonAriaLabel } from '../../modules/analytics/service/consentTranslations'

// Persistent, always-reachable control to reopen and change consent
// (FR-005) — vanilla-cookieconsent has no built-in floating reopen button,
// so this is a site-authored trigger calling CookieConsent.showPreferences()
// directly (2026-07-02 clarification; contracts/consent-module.md).
export const CookiePreferencesButton: FunctionComponent = () => {
  const { i18n } = useTranslation()
  const ariaLabel = getFloatingButtonAriaLabel(i18n.language)

  return (
    <button
      type="button"
      aria-label={ariaLabel}
      title={ariaLabel}
      onClick={() => CookieConsent.showPreferences()}
      className="fixed bottom-4 left-4 z-40 flex h-12 w-12 items-center justify-center rounded-full bg-brand text-white shadow-lg transition duration-150 ease-in-out hover:bg-brand-dark focus:outline-none focus:ring"
    >
      <ShieldCheckIcon className="h-6 w-6" aria-hidden="true" />
    </button>
  )
}
